"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));

var _semanticUiReact = require("semantic-ui-react");

require("react-loader-spinner/dist/loader/css/react-spinner-loader.css");

var _Colors = require("../00_environment/Colors");

var _loadingImage = _interopRequireDefault(require("../../assets/loading-image.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingPlaceHolder = function LoadingPlaceHolder() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: _loadingImage["default"],
    size: "small",
    verticalAlign: "middle"
  }), /*#__PURE__*/_react["default"].createElement(_reactLoaderSpinner["default"], {
    type: "ThreeDots",
    color: _Colors.primaryColor,
    width: "60",
    style: {
      marginTop: -20
    }
  }));
};

var _default = LoadingPlaceHolder;
exports["default"] = _default;